<template>
  <div class="home">
  
    <Reproductor msg="Lección #4" audio2="../mp3/SecundariaB/04SB.mp3" cover="../img/9.jpg" name="Secundaria B" />
    <Buttons/>
  </div>
</template>

<script>
// @ is an alias to /src

import Buttons from '@/components/Buttons.vue'
import Reproductor from '@/components/Reproductor.vue'
export default {
  name: 'LeccionA1',

  components: {
    Reproductor,
    Buttons,
    
  }
}
</script>
